import { render, staticRenderFns } from "./Newsx.vue?vue&type=template&id=57c41252&scoped=true&"
import script from "./Newsx.vue?vue&type=script&lang=js&"
export * from "./Newsx.vue?vue&type=script&lang=js&"
import style0 from "./Newsx.vue?vue&type=style&index=0&id=57c41252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c41252",
  null
  
)

export default component.exports